<template>
  <div class="gameplan">
    <!-- PR维护 -->
    <ContentHeader />
    <div class="content">
      <el-row>
        <el-col :span="24">
          <div class="main">
            <div class="normal_title">PR列表</div>
            <div class="card_box" v-loading="listLoading">
              <div v-if="themeList.length > 0">
                <el-card class="item-list" v-for="item in themeList" :key="item.prNumber+item.brandCode">
                  <div class="item_list_top">
                    <div class="top_title_box">
                      <div class="top_left">PR编号：{{ item.prNumber }}</div>
                      <div class="top_center">PR名称：{{ item.prName }}</div>
                    </div>
                  </div>
                  <div class="item_list_bottom">
                    <div class="bottom_left">
                      <div class="first">
                        <img class="img" src="../../assets/images/active-img.png" alt="" />
                        <div class="text">主品牌名称：{{ item.brandName }}</div>
                      </div>
                      <div class="second">主品牌编码：{{ item.brandCode }}</div>
                    </div>
                    <div class="center">
                      <div class="center-first">
                        子品牌名称：{{ item.subBrandName }}
                      </div>
                      <div>子品牌编码：{{ item.subBrandCode }}</div>
                    </div>
                    <div class="right">
                      <div class="right-btn" @click="handleOperation(item,'02')">通过</div>
                      <div class="right-btn" @click="handleOperation(item,'03')">拒绝</div>
                    </div>
                  </div>
                </el-card>

                <div class="content-pagination">
                  <el-pagination background layout="total, prev, pager, next" :total="total"
                    :page-sizes="[10, 20, 30, 40]" :current-page="queryParams.page" :page-size="queryParams.pageSize"
                    @current-change="handleCurrentChange" @size-change="handleSizeChange" />
                </div>

              </div>
              <div v-else class="no_data">暂无数据</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      custom-class="myDialog"
      :visible.sync="rejectReasonDialog"
      title="提示"
      width="400px"
      top="30vh" >

            <div >
            <el-row>
              <el-col style="margin-bottom:20px">
                <i style="color:rgb(230, 162, 60);font-size: 20px;margin-right: 10px;" class="el-icon-warning" ></i>
                <span style="font-size: 14px;">请输入拒绝理由</span>
              </el-col>
              <el-col :span="4">
                <div class="area-left">拒绝理由</div>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="18">
                <el-input  v-model="rejectReason" type="textarea" :rows="2" placeholder="请填写拒绝理由" >
                </el-input>
              </el-col>
            </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button  size="small" @click="rejectReasonDialog=false">取 消</el-button>
                <el-button  size="small" type="danger" @click="operation()">确 定</el-button>
            </span>
        </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="showConfirmDialog"
      width="30%" >
      <span>是否要{{processAction=='02'?'通过':'拒绝'}}申请？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmDialog = false">取 消</el-button>
        <el-button type="danger" @click="operation()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import gameplanApi from "@/api/gameplan";
import ContentHeader from "@/components/content-header";
export default {
  name: "PR-maintain",
  components: {
    ContentHeader,
  },
  data() {
    return {
      queryParams: {
        page: 1,
        pageSize: 10,
      },
      total: 0,
      showConfirmDialog: false,
      processAction:'',
      themeList: [],
      listLoading: false,
      rejectReason:'',
      rejectReasonDialog:false
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getGameplanPRPOUpdatePrList();
  },
  methods: {
    async getGameplanPRPOUpdatePrList() {
      this.listLoading = true;
      const { data } = await gameplanApi.getGameplanPRPOUpdatePrList(this.queryParams);
      this.listLoading = false;
      if (data.resultCode === "0") {
        this.themeList = data.resultData?.themeList || [];
        this.total = data.resultData.pageInfo.totalCounts;
      }
    },
    handleOperation(item,status){
      this.prNumber = item.prNumber
      this.processAction = status
      if(status==='02')this.showConfirmDialog = true
      else if(status==='03')this.rejectReasonDialog = true
    },
    handleConfirm(){
      this.showConfirmDialog = false
      //this.rejectReasonDialog=true
    },
    async operation(){
      let params = {
        prNumber:this.prNumber,
        processAction:this.processAction,
        rejectReason:this.rejectReason
      }
      console.log(params);
      const { data } = await gameplanApi.getGameplanPRPOUpdatePr(params);
      if (data.resultCode === "0") {
        this.$message.success("操作成功！");
        this.getGameplanPRPOUpdatePrList()
      } else {
        this.$message.error(data.resultMsg);
      }
      this.showConfirmDialog = false
      this.rejectReasonDialog=false
    },
    handleDialogClose() {
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getGameplanPRPOUpdatePrList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getGameplanPRPOUpdatePrList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
    text-align: right;
}
::v-deep .el-dialog__footer .el-button {
    width: 75px;
}
  .photo-bottom {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    height: 32px;
    line-height: 32px;
  }
::v-deep .el-card__body {
  padding: 0;
}

::v-deep .el-card {
  border: 0;
}

.header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}

.content {
  width: 100%;
  line-height: 20px;
  background-color: #f3f5f9;
  text-align: center;
  font-family: SourceHanSansSC-regular;

  .main {
    width: 894px;
    min-height: calc(100vh - 400px);
    margin: 0 auto;
    margin-bottom: 80px;
    .box-card {
      width: 894px;
      line-height: 20px;
      border-radius: 8px;
      font-size: 14px;

      .form-box {
        display: flex;
        flex-wrap: wrap;
        padding-left: 10px;
        margin-top: 20px;

        .item-lable {
          // border: 1px solid ;
          margin-right: 20px;
          margin-top: 5px;
          height: 30px;

          .item {
            width: 170px;
            height: 30px;
            border-radius: 4px;
            text-align: left;
          }
        }

        .btn {
          width: 100%;
          margin: 20px 0 30px 0;
          // margin: 60px 0 20px 70px;
        }
      }
    }

    .card_box {
      min-height: 200px;
    }

    .item-list {
      width: 100%;
      //height: 130px;
      border-radius: 8px;
      text-align: center;
      margin-bottom: 25px;

      .item_list_top {
        width: 100%;
        //height: 58px;
        background-color: #ffd6e8;
        display: flex;
        justify-content: space-between;
        padding: 13px 0;

        .top_title_box {
          display: flex;
          align-items: center;

            .top_left {
            // width: 172px;
            font-weight: 600;
            color: #cd1231;
            font-size: 18px;
            text-align: left;
            margin: 0 40px 0 20px;
            min-width: 180px;
          }

          .top_center {
            // width: 174px;
            font-size: 13px;
            font-weight: bold;
            margin-right: 10px;
          }
        }
        .right_btn_box {
          display: flex;
          min-width: 295px;
        }

        .right_btn {
          padding:3px 12px;
          font-size: 12px;
          height: 21px;
          border-radius: 4px;
          text-align: center;
          background-color: #ffffff;
          border: 1px solid #2185d0;
          color: #2185d0;
          margin-right: 20px;
          cursor: pointer;
        }

        .right_link{
          color: #2185d0;
          padding:5px 20px 5px 0;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .item_list_bottom {
        width: 100%;
        //height: 72px;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
        line-height: 25px !important;
        padding-bottom: 8px;

        .bottom_left {
          min-width: 120px;

          .first {
            display: flex;
            margin-bottom: 4px;
            margin-top: 10px;

            .img {
              margin-top: 6px;
              width: 15px;
              margin-right: 3px;
            }

            .text {
              height: 20px;
              font-size: 13px;
              text-align: left;
            }
          }

          .second {
            height: 20px;
            font-size: 13px;
            text-align: left;
          }
        }

        .center {
          margin-left: 58px;
          font-size: 13px;
          text-align: left;
          color: #101010;

          .center-first {
            margin-top: 10px;
          }
        }

        .right {
          // padding:3px 12px;
          // font-size: 12px;
          // border-radius: 4px;
          // text-align: center;
          // background-color: #ffffff;
          //border: 1px solid #2185d0;
          color: #2185d0;
          //margin-right: 20px;
          flex: 0.88;
          line-height: 68px;
          font-size: 16px;
          text-align: right;
          display: flex;
          justify-content: flex-end;
          margin-right:-40px;
          .right-btn{
            cursor: pointer;
            width: 80px;
            text-align:center;
          }
        }
      }
    }
  }
}

.no_data {
  background-color: #fff;
  color: grey;
  width: 100%;
  min-height: 120px;
  line-height: 120px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
}

.form_style {
  margin: 10px 20px;
}

.edit_dialog {
  .el-select {
    width: 100%;
  }
}
</style>
